import Cookies from 'js-cookie';

class ProductLayout {
  constructor(options = {}) {
    this.config = {
      expireDays: 365,
      cookiePath: '/',
      controls: document.querySelector('[data-module="ProductLayout__Controls"]'),
      list: document.querySelector('[data-module="ProductLayout__List"]'),
      ...options
    };
  }

  init() {
    const { controls, list, expireDays, cookiePath } = this.config;

    if (!controls) {
      return;
    }

    const inputs = controls.querySelectorAll('input[name=productlayout]');

    if (!inputs) {
      return;
    }

    inputs.forEach(input => {
      // when input is changed
      input.addEventListener('change', () => {
        // set cookie of checked type
        if (input.checked) {
          Cookies.set('png_productLayout', input.value, {
            expires: expireDays,
            path: cookiePath
          });

          if (!list) {
            return;
          }

          // remove type-class from productgrid
          const classes = list.className.split(' ').filter(c => !c.startsWith('c-productgrid--'));
          list.className = classes.join(' ').trim();

          // add type-class to productgrid
          list.classList.add(`c-productgrid--${input.value}`);
        }
      });
    });
  }
}

export default ProductLayout;
